import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient.js";
import { useAuth } from "./auth.jsx";
import { Minus, Square } from "lucide-react";

export default function WeekAhead() {
  const { me } = useAuth();
  const [rows, setRows] = useState([]);
  const [names, setNames] = useState({});
  const [collapsed, setCollapsed] = useState(() => { try { return localStorage.getItem("tpms_week_min") === "1"; } catch { return false; } });

  const load = async () => {
    try {
      if (!me || !me.id) return;
      const today = new Date(); const end = new Date(Date.now() + 7 * 86400000);
      const iso = (d) => d.toISOString().slice(0, 10);
      const { data } = await supabase.from("agenda_events").select("*")
        .eq("owner_id", me.id).gte("date", iso(today)).lte("date", iso(end)).order("date");
      const evs = data || [];
      const otherIds = [...new Set(evs.map((e) => e.created_by).filter((c) => c && c !== me.id))];
      let nm = {};
      if (otherIds.length) { const { data: ps } = await supabase.from("profiles").select("id, full_name").in("id", otherIds); (ps || []).forEach((x) => { nm[x.id] = x.full_name; }); }
      setNames(nm); setRows(evs);
    } catch { setRows([]); }
  };
  useEffect(() => { load(); const t = setInterval(load, 60000); const f = () => load();
    window.addEventListener("focus", f);
    let ch = null;
    try { ch = supabase.channel("rt-week-" + (me && me.id)).on("postgres_changes", { event: "*", schema: "public", table: "agenda_events" }, () => load()).subscribe(); } catch {}
    return () => { clearInterval(t); window.removeEventListener("focus", f); try { ch && ch.unsubscribe(); } catch {} };
  }, [me && me.id]);

  if (!rows.length) return null;
  const todayISO = new Date().toISOString().slice(0, 10);
  const tomISO = new Date(Date.now() + 86400000).toISOString().slice(0, 10);
  const fmt = (d) => d === todayISO ? "اليوم" : d === tomISO ? "غدًا" : new Date(d + "T12:00").toLocaleDateString("ar-u-nu-latn", { weekday: "long", day: "numeric", month: "short" });

  return (
    <div style={{ position: "fixed", bottom: 18, right: 18, zIndex: 840, width: collapsed ? "auto" : "min(320px, 92vw)", direction: "rtl",
      background: "color-mix(in srgb, var(--surface) 88%, transparent)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)",
      border: "1.5px solid transparent", borderImage: "var(--card-glow) 1", borderRadius: 0, boxShadow: "4px 4px 0 color-mix(in srgb, var(--accent) 38%, transparent)", overflow: "hidden", fontFamily: "Tajawal, sans-serif" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 15px", cursor: "pointer", borderBottom: collapsed ? "none" : "1px solid var(--line)" }}
        onClick={() => { const v = !collapsed; setCollapsed(v); try { localStorage.setItem("tpms_week_min", v ? "1" : "0"); } catch {} }}>
        <b style={{ fontSize: 14, color: "var(--text)" }}>أجندتك هذا الأسبوع</b>
        <span style={{ fontSize: 12, fontWeight: 800, color: "var(--accent)" }}>{rows.length}</span>
        <span style={{ flex: 1 }} />
        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 22, height: 22, borderRadius: 6, border: "1px solid var(--line)", color: "var(--faint)" }} title={collapsed ? "تكبير" : "تصغير"}>
          {collapsed ? <Square size={11} /> : <Minus size={14} />}
        </span>
      </div>
      {!collapsed && (
        <div style={{ padding: "10px 15px 13px", maxHeight: 260, overflowY: "auto" }}>
          {rows.map((e) => (
            <div key={e.id} style={{ padding: "7px 8px", borderBottom: "1px dashed var(--line)", ...(e.created_by !== me.id ? { background: "#dc262610" } : {}) }}>
              <div style={{ display: "flex", gap: 8, alignItems: "baseline" }}>
                <span style={{ fontSize: 13.5, fontWeight: 800, color: "var(--text)", flex: 1 }}>{e.title}</span>
                <span style={{ fontSize: 11.5, fontWeight: 800, color: e.date === todayISO ? "var(--accent)" : "var(--faint)", whiteSpace: "nowrap" }}>{fmt(e.date)}</span>
              </div>
              <div style={{ fontSize: 11.5, color: "var(--faint)", marginTop: 2 }}>
                {e.type}{e.created_by !== me.id ? " · أضافه " + (names[e.created_by] || "الإدارة") : ""}{e.note ? " · " + e.note : ""}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
